import React from "react";
import { useSeriesShowContext } from "../SeriesShowApp";

const CollectionDetailsCard = () => {
  const { series } = useSeriesShowContext();
  const venueName = series.subline_data && series.subline_data.venue_name;

  return (
    <div className="series-detail-card series-detail-card--flush">
      <div
        className="series-collection-hero"
        style={series.image_url ? { backgroundImage: `url(${series.image_url})` } : undefined}
      />
      <div className="series-detail-card-body">
        <h4 className="series-detail-card-title mb-4">Collection Details</h4>
        <dl className="series-collection-details mb-0">
          <div className="series-collection-row">
            <dt>Title</dt>
            <dd>{series.name}</dd>
          </div>
          <div className="series-collection-row">
            <dt>Venue</dt>
            <dd>{venueName || "—"}</dd>
          </div>
          <div className="series-collection-row">
            <dt>Age Restriction</dt>
            <dd>{series.age_restriction || "—"}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default CollectionDetailsCard;
